import wait from './wait'

const SIMULATE_DELAYS = false
const defaultHeaders = {
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  Pragma: 'no-cache',
  Expires: 0
}

const ERROR_LOG_MAX_LENGTH = 20
const MAX_RETRIES = 2

const errorLog = []
errorLog.push = function () {
  if (this.length >= ERROR_LOG_MAX_LENGTH) {
    this.shift()
  }
  return Array.prototype.push.apply(this, arguments)
}

export const getErrorLog = () => errorLog.map(e => {
  return {
    time: e.time,
    message: `Function: ${e.funcName}, Error: ${e.message}`
  }
})

export const addError = ({ funcName, message }) => {
  errorLog.push({ funcName, message, time: new Date() })
}

const doIt = async ({ url, headers, method = 'get', body = undefined, funcName, timeout = 10000, retries = 0 }) => {
  funcName = funcName || url
  const combinedHeaders = Object.assign({}, defaultHeaders, headers || {})
  if (body) {
    body = JSON.stringify(body)
  }
  let response

  if (SIMULATE_DELAYS) {
    await wait(1000)
  }

  try {
    response = await Promise.race([
      wait(timeout, true),
      fetch(url, { headers: combinedHeaders, method, body })
    ])
  } catch (err) {
    let shouldRetry = false
    if (err.message === 'Timeout Error') {
      addError({ funcName, message: 'Timeout Error' })
      if (retries < MAX_RETRIES) {
        shouldRetry = true
      }
    } else if (err.message === 'Network request failed') {
      addError({ funcName, message: 'Network request failed' })
      if (retries < MAX_RETRIES) {
        shouldRetry = true
      }
    } else if (err.message === 'Failed to fetch') {
      addError({ funcName, message: 'Server unavailable' })
      if (retries < MAX_RETRIES) {
        shouldRetry = true
      } else {
        throw new Error('Server not available')
      }
    }
    if (shouldRetry) {
      return doIt({ url, headers, method, body, funcName, timeout, retries: retries + 1 })
    }
    throw err
  }

  if (response.status === 204 || response.status === 202) {
    return null
  }

  if (response.status >= 400) {
    let errorJSON
    try {
      errorJSON = await response.json()
    } catch (err) {
      const errorText = await response.text()
      addError({ funcName, message: errorText })
      throw new Error(`code: ${response.status}, error: ${errorText}`)
    }
    const error = errorJSON.error || errorJSON
    const errorInstance = new Error(error.message)
    errorInstance.code = errorJSON.status
    errorInstance.errorCode = error.code
    errorInstance.errors = errorJSON.errors
    addError({ funcName, message: error.message })
    throw errorInstance
  }

  return response.json()
}

export default doIt
